import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
  IconButton,
  Card,
  CardContent,
  Divider,
  Snackbar,
  Alert
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';

const ContactModal = ({ open, onClose, contactInfo = { email: 'kyle7949@sa21c.com', phone: '010-8626-2111', isIframe: false } }) => {
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');

  const copyToClipboard = (text, type) => {
    navigator.clipboard.writeText(text).then(() => {
      setSnackbarMessage(`${type}이(가) 클립보드에 복사되었습니다!`);
      setSnackbarOpen(true);
    }).catch(() => {
      setSnackbarMessage('복사에 실패했습니다.');
      setSnackbarOpen(true);
    });
  };

  const handleEmailClick = () => {
    window.location.href = `mailto:${contactInfo.email}`;
  };

  const handlePhoneClick = () => {
    window.location.href = `tel:${contactInfo.phone}`;
  };

  return (
    <>
      <Dialog 
        open={open} 
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            background: 'linear-gradient(135deg, #FFFFFF 0%, #F8F9FA 100%)'
          }
        }}
      >
        <DialogTitle sx={{ 
          textAlign: 'center', 
          pb: 1,
          background: 'linear-gradient(135deg, #1565C0 0%, #37474F 100%)',
          color: 'white',
          position: 'relative'
        }}>
          <BusinessCenterIcon sx={{ fontSize: 40, mb: 1, display: 'block', mx: 'auto' }} />
          <Typography variant="h5" sx={{ 
            fontWeight: 800,
            textShadow: '0 2px 4px rgba(0,0,0,0.3)',
            color: 'white'
          }}>
            도입 상담 문의
          </Typography>
          <Typography variant="body2" sx={{ 
            opacity: 1, 
            mt: 1,
            fontWeight: 500,
            textShadow: '0 1px 2px rgba(0,0,0,0.2)',
            color: 'white'
          }}>
            {contactInfo.isIframe 
              ? "영업 담당자를 통한 전문 상담을 받아보세요" 
              : "빅스데이터 AI 기반 질의응답 시스템 도입에 대한 상담을 받아보세요"
            }
          </Typography>
          <IconButton
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'white'
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 4 }}>
          <Typography variant="h6" gutterBottom sx={{ 
            textAlign: 'center', 
            color: 'primary.main',
            mb: 4,
            mt: 3,
            fontWeight: 600
          }}>
            📞 연락처 정보
          </Typography>

          {/* 이메일 카드 */}
          <Card sx={{ mb: 2, border: '1px solid #E3F2FD' }}>
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                  <EmailIcon sx={{ color: '#1565C0', mr: 2, fontSize: 28 }} />
                  <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.9rem' }}>
                      이메일
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#1565C0' }}>
                      {contactInfo.email}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <IconButton 
                    onClick={() => copyToClipboard(contactInfo.email, '이메일')}
                    size="small"
                    sx={{ 
                      backgroundColor: '#E3F2FD',
                      '&:hover': { backgroundColor: '#BBDEFB' }
                    }}
                  >
                    <ContentCopyIcon fontSize="small" />
                  </IconButton>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleEmailClick}
                    sx={{ 
                      minWidth: 'auto',
                      px: 2,
                      backgroundColor: '#1565C0',
                      '&:hover': { backgroundColor: '#0D47A1' }
                    }}
                  >
                    메일 보내기
                  </Button>
                </Box>
              </Box>
            </CardContent>
          </Card>

          {/* 전화번호 카드 */}
          <Card sx={{ mb: 3, border: '1px solid #E8F5E8' }}>
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                  <PhoneIcon sx={{ color: '#2E7D32', mr: 2, fontSize: 28 }} />
                  <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.9rem' }}>
                      전화번호
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#2E7D32' }}>
                      {contactInfo.phone}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <IconButton 
                    onClick={() => copyToClipboard(contactInfo.phone, '전화번호')}
                    size="small"
                    sx={{ 
                      backgroundColor: '#E8F5E8',
                      '&:hover': { backgroundColor: '#C8E6C9' }
                    }}
                  >
                    <ContentCopyIcon fontSize="small" />
                  </IconButton>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handlePhoneClick}
                    sx={{ 
                      minWidth: 'auto',
                      px: 2,
                      backgroundColor: '#2E7D32',
                      '&:hover': { backgroundColor: '#1B5E20' }
                    }}
                  >
                    전화 걸기
                  </Button>
                </Box>
              </Box>
            </CardContent>
          </Card>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ 
            backgroundColor: '#F5F5F5', 
            p: 3, 
            borderRadius: 2,
            textAlign: 'center'
          }}>
            <Typography variant="body1" sx={{ mb: 2, fontWeight: 600 }}>
              🚀 빠른 도입 프로세스
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
              • 상담 신청 → 데모 시연 → 맞춤 제안서 → 계약<br />
              • 평균 1-2주 내 시스템 구축 완료<br />
              • 전체 소스코드 제공으로 완전한 기술 검증 가능
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 3, pt: 0 }}>
          <Button 
            onClick={onClose} 
            variant="outlined"
            sx={{ 
              px: 4,
              borderColor: '#9E9E9E',
              color: '#616161'
            }}
          >
            닫기
          </Button>
        </DialogActions>
      </Dialog>

      {/* 복사 완료 스낵바 */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={() => setSnackbarOpen(false)} 
          severity="success" 
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ContactModal; 